import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import StickyWhatsAppButton from './components/StickyWhatsAppButton';

import './App.css';

/* Critical */
import Home from './components/Home';

/* Lazy Components */
const Navbar = lazy(() => import('./components/Navbar'));
const Footer = lazy(() => import('./components/Footer'));
const AboutReddyAnna = lazy(() => import('./components/AboutReddyAnna'));
const SportsCategories = lazy(() => import('./components/SportsCategories'));
const CommunitySection = lazy(() => import('./components/CommunitySection'));
const TrustedPlatformSection = lazy(() => import('./components/TrustedPlatformSection'));
const ReddyAnnaBook = lazy(() => import('./pages/ReddyAnnaBook'));

const VideoSection = lazy(() => import('./components/VideoSection'));
const AboutUs = lazy(() => import('./components/Aboutus'));
const WhyChooseUs = lazy(() => import('./components/WhyChooseUs'));
const Blog = lazy(() => import('./components/blog'));
const Benefit = lazy(() => import('./components/benefits'));
const Testimonial = lazy(() => import('./components/Testimonial'));
const AddFundsSection = lazy(() => import('./components/AddFundsSection'));
const FAQSection = lazy(() => import('./components/Faq'));
const PeopleAlsoSearch = lazy(() => import('./components/PeopleAlsoSearch'));

/* Pages */
const Services = lazy(() => import('./pages/Services'));
const Platforms = lazy(() => import('./pages/Platforms'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const Terms = lazy(() => import('./pages/Terms'));
const Disclaimer = lazy(() => import('./pages/Disclaimer'));
const ElevenXPlayPage = lazy(() => import('./pages/ElevenXPlayPage'));
const Laser247Page = lazy(() => import('./pages/Laser247'));
const Cricket99 = lazy(() => import('./pages/Cricket99'));
const CricketBettingPage = lazy(() => import('./pages/CricketBetting'));
const TennisBettingPage = lazy(() => import('./pages/TennisBetting'));
const FootballBettingPage = lazy(() => import('./pages/FootballBetting'));
const HorseRaceBettingPage = lazy(() => import('./pages/horseRaceBetting'));
const Casino = lazy(() => import('./pages/Casino'));
const IndianCardGamesBettingPage = lazy(() => import('./pages/IndianCardGames'));
const About = lazy(() => import('./pages/AboutUs'));
const SportsID = lazy(() => import('./pages/SportsId'));
const Contact = lazy(() => import('./pages/Contact'));
const Blogs = lazy(() => import('./pages/Blogs'));
const BlogDetails = lazy(() => import('./pages/BlogDetails'));

function AppContent() {
  const location = useLocation();

  const hideWhatsAppRoutes = [
    '/contact','/privacy-policy','/terms-and-conditions','/disclaimer',
    '/blogs','/services','/cricket-betting','/tennis-betting',
    '/horse-race-betting','/indian-card-games','/football-betting',
    '/casino','/platforms','/11xplay','/laser247','/cricbet99',
    '/sports-id','/about',
  ];

  const hideWhatsAppIcon = hideWhatsAppRoutes.some(route =>
    location.pathname.startsWith(route)
  );

  return (
    <div className="App">

      <Suspense fallback={null}>
        <Navbar />
      </Suspense>

      <Routes>

        {/* Home */}
        <Route
          path="/"
          element={
            <section>

              <section id="home">
                <Home />
              </section>

              <section id="about">
                <Suspense fallback={null}><AboutReddyAnna /></Suspense>
              </section>

              <section id="videosection">
                <Suspense fallback={null}><VideoSection /></Suspense>
              </section>

              <section id="aboutus">
                <Suspense fallback={null}><AboutUs /></Suspense>
              </section>

              <section id="whychooseus">
                <Suspense fallback={null}><WhyChooseUs /></Suspense>
              </section>

              <section id="blog">
                <Suspense fallback={null}><Blog /></Suspense>
              </section>

              <section>
                <Suspense fallback={null}><Benefit /></Suspense>
              </section>

              <section>
                <Suspense fallback={null}><SportsCategories /></Suspense>
              </section>

              <section id="testimonial">
                <Suspense fallback={null}><Testimonial /></Suspense>
              </section>

              <section id="addfunds">
                <Suspense fallback={null}><AddFundsSection /></Suspense>
              </section>

              <section id="faq">
                <Suspense fallback={null}><FAQSection /></Suspense>
              </section>

              <section id="community">
                <Suspense fallback={null}><CommunitySection /></Suspense>
              </section>

              <section id="trustedplatform">
                <Suspense fallback={null}><TrustedPlatformSection /></Suspense>
              </section>
              <section id="peoplealsosearch">
                <Suspense fallback={null}><PeopleAlsoSearch /></Suspense>
              </section>

            </section>
          }
        />

        {/* Pages */}
        <Route path="/contact" element={<Suspense fallback={null}><Contact /></Suspense>} />
        <Route path="/reddy-anna-book" element={<Suspense fallback={null}><ReddyAnnaBook /></Suspense>} />

        <Route path="/services" element={<Suspense fallback={null}><Services /></Suspense>} />
        <Route path="/cricket-betting" element={<Suspense fallback={null}><CricketBettingPage /></Suspense>} />
        <Route path="/tennis-betting" element={<Suspense fallback={null}><TennisBettingPage /></Suspense>} />
        <Route path="/horse-race-betting" element={<Suspense fallback={null}><HorseRaceBettingPage /></Suspense>} />
        <Route path="/indian-card-games" element={<Suspense fallback={null}><IndianCardGamesBettingPage /></Suspense>} />
        <Route path="/football-betting" element={<Suspense fallback={null}><FootballBettingPage /></Suspense>} />
        <Route path="/casino" element={<Suspense fallback={null}><Casino /></Suspense>} />

        <Route path="/platforms" element={<Suspense fallback={null}><Platforms /></Suspense>} />
        <Route path="/11xplay" element={<Suspense fallback={null}><ElevenXPlayPage /></Suspense>} />
        <Route path="/laser247" element={<Suspense fallback={null}><Laser247Page /></Suspense>} />
        <Route path="/cricbet99" element={<Suspense fallback={null}><Cricket99 /></Suspense>} />

        <Route path="/about" element={<Suspense fallback={null}><About /></Suspense>} />
        <Route path="/sports-id" element={<Suspense fallback={null}><SportsID /></Suspense>} />

        <Route path="/privacy-policy" element={<Suspense fallback={null}><PrivacyPolicy /></Suspense>} />
        <Route path="/terms-and-conditions" element={<Suspense fallback={null}><Terms /></Suspense>} />
        <Route path="/disclaimer" element={<Suspense fallback={null}><Disclaimer /></Suspense>} />

        <Route path="/blogs" element={<Suspense fallback={null}><Blogs /></Suspense>} />
        <Route path="/blogs/:title" element={<Suspense fallback={null}><BlogDetails /></Suspense>} />

        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>

      {!hideWhatsAppIcon && <StickyWhatsAppButton />}

      <Suspense fallback={null}>
        <Footer />
      </Suspense>

    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;